import React, { useEffect } from "react";

import ToggleSwitch from "../../../atoms/ToggleSwitch";
import useDebounceCallback from "../../../hooks/useDebounceCallback";
import { IIssue } from "../../../state";

export type Props = {
  issue: IIssue;
  label: string;
  disabled?: boolean;
  onChange: (id: number, check: boolean) => void;
};

const SwitchBox: React.FC<Props> = ({ issue, disabled, onChange, label }) => {
  const [checked, setChecked] = React.useState(
    label === "みんなの回答を公開"
      ? !!issue.answer_opened
      : !!issue.name_opened,
  );
  const [debounced] = useDebounceCallback((check: boolean) =>
    onChange(issue.id, check),
  );

  useEffect(() => {
    if (disabled) {
      setChecked(false);
    }
  }, [disabled]);

  useEffect(() => {
    if (label === "みんなの回答を公開") {
      setChecked(!!issue.answer_opened);
    } else {
      setChecked(!!issue.name_opened);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [issue]);

  return (
    <ToggleSwitch
      label={label}
      checked={checked}
      disabled={disabled}
      id={issue.id.toString() + label}
      onChange={() => {
        setChecked(!checked);
        debounced(!checked!);
      }}
    />
  );
};

export default SwitchBox;
